import { Loadable } from '@gdp/react-app/lib/helpers/loadable';

export const LoadableExpenseRoutes = Loadable(
  './ExpenseRoutes',
  () => import(/* webpackChunkName: "Expense" */ './ExpenseRoutes'),
  () => [(require as any).resolveWeak('./ExpenseRoutes')]
);
